export const COLOR_CODE = {
  STRONG: {
    STEEL_GREY: '#6C676E',
    SEPIA: '#483C2C',
    BROWN: '#6D4C33',
    MAROON: '#800000',
    PURPLE: '#800080',
    PANSY: '#433171',
    SAXE_BLUE: '#5A7993',
    ORIENTAL_BLUE: '#304285',
    COBALT_BLUE: '#0062A0',
    CERULEAN_BLUE: '#0073A2',
    ROYAL_BLUE: '#4169E1',
    MARINE_BLUE: '#00526B',
    MALACHITE_GREEN: '#007E4E',
    GREEN: '#009A57',
    EMERALD_GREEN: '#00A474',
    GRASS_GREEN: '#737C3E',
    YELLOW_OCHER: '#B8883B',
    DEEP_ORANGE: '#E37D00',
    CARROT_ORANGE: '#C55431',
    GOLDEN_YELLOW: '#E89A3C',
    FIREBRICK: '#B22222',
    ROSE: '#DB3561',
    OLD_ROSE: '#C67A85',
    STRAWBERRY: '#BB004B',
  },
  PALE: {
    GREY: '#E3E2E0',
    SCARLET: '#F5B090',
    CORAL: '#F9C499',
    ORANGE: '#FCD7A1',
    GOLD: '#FEE9A9',
    YELLOW: '#FFF9B1',
    GREEN_YELLOW: '#ECF0B0',
    LIGHT_GREEN: '#D7E7AF',
    SEA_GREEN: '#C0DEAE',
    GREEN: '#A5D4AD',
    TURQUOISE: '#A4D6C1',
    CYAN: '#A2D7D4',
    SKY_BLUE: '#A1D8E6',
    LIGHT_BLUE: '#9FD9F6',
    DODGER_BLUE: '#A1CBEC',
    BLUE: '#A3BCE2',
    NAVY: '#A4ACD6',
    BLUE_VIOLET: '#A59ACA',
    INDIGO: '#BBA1CC',
    PURPLE: '#CFA7CD',
    VIOLET: '#E2AECF',
    MAGENTA: '#F4B4D0',
    PINK: '#F5B3C2',
    RED: '#F5B2B2',
    SALMON: '#F5B1A2',
  },
};
export const COLOR_NAME = {
  STRONG: {
    STEEL_GREY: 'strongSteelGrey',
    SEPIA: 'strongSepia',
    BROWN: 'strongBrown',
    MAROON: 'strongMaroon',
    PURPLE: 'strongPurple',
    PANSY: 'strongPansy',
    SAXE_BLUE: 'strongSaxeBlue',
    ORIENTAL_BLUE: 'strongOrientalBlue',
    COBALT_BLUE: 'strongCobaltBlue',
    CERULEAN_BLUE: 'strongCeruleanBlue',
    ROYAL_BLUE: 'strongRoyalBlue',
    MARINE_BLUE: 'strongMarineBlue',
    MALACHITE_GREEN: 'strongMalachiteGreen',
    GREEN: 'strongGreen',
    EMERALD_GREEN: 'strongEmeraldGreen',
    GRASS_GREEN: 'strongGrassGreen',
    YELLOW_OCHER: 'strongYellowOcher',
    DEEP_ORANGE: 'strongDeepOrange',
    CARROT_ORANGE: 'strongCarrotOrange',
    GOLDEN_YELLOW: 'strongGoldenYellow',
    FIREBRICK: 'strongFirebrick',
    ROSE: 'strongRose',
    OLD_ROSE: 'strongOldRose',
    STRAWBERRY: 'strongStrawberry',
  },
  PALE: {
    GREY: 'paleGrey',
    SCARLET: 'paleScarlet',
    LIGHT_BLUE: 'paleLightBlue',
    LIGHT_GREEN: 'paleLightGreen',
    PURPLE: 'palePurple',
    ORANGE: 'paleOrange',
    BLUE: 'paleBlue',
    GREEN: 'paleGreen',
    MAGENTA: 'paleMagenta',
    YELLOW: 'paleYellow',
    BLUE_VIOLET: 'paleBlueViolet',
    CYAN: 'paleCyan',
    RED: 'paleRed',
    CORAL: 'paleCoral',
    DODGER_BLUE: 'paleDodgerBlue',
    SEA_GREEN: 'paleSeaGreen',
    VIOLET: 'paleViolet',
    GOLD: 'paleGold',
    NAVY: 'paleNavy',
    TURQUOISE: 'paleTurquoise',
    PINK: 'palePink',
    GREEN_YELLOW: 'paleGreenYellow',
    INDIGO: 'paleIndigo',
    SKY_BLUE: 'paleSkyBlue',
    SALMON: 'paleSalmon',
  },
};

export const COLOR_PALETTE_DEFAULT_COLOR = {
  CODE: COLOR_CODE.STRONG.STEEL_GREY,
  NAME: COLOR_NAME.STRONG.STEEL_GREY,
};
